export { GlobalAccounts } from './globalAccounts.component';
export { GlobalAccountsDetailsContainer as GlobalAccountsDetails } from './globalAccountsDetails.component';
